import { render, staticRenderFns } from "./Qualifications.vue?vue&type=template&id=bff99452&scoped=true"
import script from "./Qualifications.vue?vue&type=script&lang=js"
export * from "./Qualifications.vue?vue&type=script&lang=js"
import style0 from "./Qualifications.vue?vue&type=style&index=0&id=bff99452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff99452",
  null
  
)

export default component.exports